module.exports = __webpack_public_path__ + "img/274478644_277059941227543_8631623597410620668_n.72696b07.jpg";